.fieldContainer {
    margin: 0px 10px 10px 10px;
}

.metricDescription {
    margin: 0px 10px 10px 10px;
}
